import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }) {
  return <div className={cn('vp-skeleton rounded-md', className)} {...props} />;
}

function SkeletonCard({ className }) {
  return (
    <div className={cn('rounded-lg border border-border p-6 space-y-4', className)}>
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-8 w-1/2" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  );
}

function SkeletonTable({ rows = 5, className }) {
  return (
    <div className={cn('space-y-3', className)}>
      <Skeleton className="h-10 w-full" />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-12 w-full" />
      ))}
    </div>
  );
}

function SkeletonAvatar({ className }) {
  return <Skeleton className={cn('h-10 w-10 rounded-full', className)} />;
}

export { Skeleton, SkeletonCard, SkeletonTable, SkeletonAvatar };
